import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ProgressBar from 'react-bootstrap-v5/lib/ProgressBar';
import './BbTimer.css';

/*
This timer goes back to the old brainbout where DIFFICULTY played
a role in how many seconds each round took.  I leave most code in place
so that the difficulty feature can be reimplemented in the
future.  For now, this semantic-web version, has a single
hard-coded difficulty value.
*/

class BbTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: parseInt(0, 10),
    };
  }

  componentDidMount() {
    this.startTimer();
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.t !== this.props.t) {
      this.startTimer();
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    clearInterval(this.state.timer);
  }

  /*
   * Progress Bar (Timer)
   */
  tick() {
    const st = this.state.timer + 100 / (parseInt(this.props.difficulty, 10) + 10); // 11
    if (this.state.timer >= 100) {
      this.stopTimer();
    } else {
      let timeToPlay = 12 + parseInt(this.props.difficulty, 10);
      if (Number.isNaN(timeToPlay)) {
        timeToPlay = '';
      }
      this.setState({
        timer: st,
      });
      try {
        ReactDOM.render(
          <ProgressBar striped variant="danger" now={this.state.timer} min={0} key={112122} />,
          document.getElementById('bb-timer-section'),
        );
      } catch (error) {
        clearInterval(this.timer);
        console.log(`ERROR: ${error}`);
      }
    }
  }

  startTimer() {
    this.setState({
      timer: parseInt(-1, 10),
    });
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  stopTimer() {
    clearInterval(this.timer);
  }

  render() {
    return null;
  }
}
export default BbTimer;
